<template>
<router-view/>
</template>

<script>
export default {
  name: "sectionLayout"
}
</script>

<style scoped>

</style>